export function digits_only(value) {
  const digits_value = String(value || '').replace(/[^0-9]/g, '');
  return digits_value;
}

export function parse_range_band(compact_band, side) {
  const range_match = compact_band.match(/^R\s*([\d\s,]+)\s*-\s*R\s*([\d\s,]+)$/i);
  if (!range_match) {
    return null;
  }
  const range_value = side === 'from' ? digits_only(range_match[1]) : digits_only(range_match[2]);
  return range_value;
}

export function get_progress_dot_class(item) {
  if (!item) {
    const empty_progress_class = '';
    return empty_progress_class;
  }

  if (item.dot_class) {
    const dot_class = item.dot_class;
    return dot_class;
  }

  if (item.dot_tone) {
    const dot_tone_class = `is-${item.dot_tone}`;
    return dot_tone_class;
  }

  const default_progress_class = 'is-green';
  return default_progress_class;
}

export function get_progress_width_class(percent) {
  const value = Number(percent);

  if (!Number.isFinite(value)) {
    const empty_width_class = 'is-0';
    return empty_width_class;
  }

  const clamped = Math.max(0, Math.min(100, value));
  const bucket = Math.round(clamped / 10) * 10;

  const progress_width_class = `is-${bucket}`;
  return progress_width_class;
}

export const delegation_of_authority_hooks = {
  beforeDestroy() {
    document.body.classList.remove('doa-modal-open');
  }
};
